import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { VALID_EMAIL } from '../../../../../core/constants/general.constant';
import { SuccessPopupComponent } from '../../../../../core/libraries/popup/components/success-popup/success-popup.component';
import { PasswordService } from '../../../../../core/services/api/password/password.service';
import { LoaderService } from '../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-forgot-password',
    standalone: false,
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
    protected email = this.activatedRoute.snapshot.queryParamMap.get('email') || '';
    protected resetPasswordForm = this.fb.group({
        email: ['', [Validators.required, Validators.pattern(VALID_EMAIL)]],
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
        private fb: NonNullableFormBuilder,
        private loaderService: LoaderService,
        private passwordService: PasswordService,
        private router: Router,
    ) {}

    protected submit(): void {
        if (this.resetPasswordForm.invalid) {
            return;
        }

        const email = this.resetPasswordForm.value.email?.trim();
        this.loaderService.show();
        this.passwordService
            .forgotPassword(email as string)
            .pipe(finalize(() => this.loaderService.hide()))
            .subscribe({
                next: () => {
                    this.router.navigate(['/verify-reset-password'], { queryParams: { email } });
                },
                error: (error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                },
            });
    }
}
